class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.querySelector('#ProductCountDesktop');
    const DesktopCountContainer = document.querySelector('#ProductCountDesktop span');
    const mobileCountContainer = document.querySelector('#mobileProductCount');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop && mobileCountContainer) {
      DesktopCountContainer.innerHTML = count;
      containerDesktop.classList.remove('loading');
      mobileCountContainer.innerHTML = count
    }
  }

  // static renderFilters(html, event) {
  //   const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

  //   const facetDetailsElements =
  //     parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
  //   const matchesIndex = (element) => {
  //     const jsFilter = event ? event.target.closest('.js-filter') : undefined;
  //     return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
  //   }
  //   const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
  //   const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

  //   facetsToRender.forEach((element) => {
  //     document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
  //   });

  //   FacetFiltersForm.renderActiveFacets(parsedHTML);
  //   FacetFiltersForm.renderAdditionalElements(parsedHTML);

  //   if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  // }



static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
        parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');

    const matchesIndex = (element) => {
        const jsFilter = event ? event.target.closest('.js-filter') : undefined;
        return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };

    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    // Groups the user isn't currently interacting with get their content replaced.
    // Desktop accordion state lives on the .facets__summary button (aria-expanded), which is
    // part of that replaced content, so it's captured beforehand and re-applied after.
    // Mobile groups use a native <details>, whose own `open` attribute lives on the
    // untouched wrapper element and survives an innerHTML swap automatically.
    facetsToRender.forEach((element) => {
        const targetElement = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);
        if (!targetElement) return;

        const previousExpanded = targetElement.querySelector('.facets__summary')?.getAttribute('aria-expanded');
        targetElement.innerHTML = element.innerHTML;

        if (previousExpanded !== null && previousExpanded !== undefined) {
            const newSummary = targetElement.querySelector('.facets__summary');
            if (newSummary) newSummary.setAttribute('aria-expanded', previousExpanded);
        }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event?.target.closest('.js-filter'));
}




  

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop', '.active-facets-mobile-drawer'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      const target = document.querySelector(selector);
      if (!activeFacetsElement || !target) return;
      target.innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }

    // Mobile groups don't use .facets__selected/.facets__summary at all (that's desktop-only
    // markup) — they show the active count as .mobile-facet-active-count inside
    // .mobile-facets__summary. Since this group is otherwise excluded from the general
    // content-replace pass (so its open state / scroll position isn't disrupted while the
    // user is still interacting with it), its own header badge would never refresh without
    // this — swap the whole <summary> so the badge count/visibility stays correct.
    const targetMobileSummary = target.querySelector('.mobile-facets__summary');
    const sourceMobileSummary = source.querySelector('.mobile-facets__summary');

    if (targetMobileSummary && sourceMobileSummary) {
      targetMobileSummary.outerHTML = sourceMobileSummary.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
    // Add focus to the "Clear All" button after rendering
    setTimeout(() => {
    this.addFocusToClearAll();
  }, 1000);
  }
  onSubmitHandler(event) {
    event.preventDefault();
    // Anything inside the mobile drawer's <form class="mobile-facets"> submits that form's
    // own complete param set on its own (it already contains every filter + sort control).
    // This used to only catch the old plain-checkbox class name (`mobile-facets__checkbox`)
    // and otherwise fell through to a desktop-forms branch keyed off `form.id ===
    // 'FacetFiltersFormMobile'` — an id that only exists on the outer <menu-drawer>, never
    // on the <form> itself, so that branch could never actually match and silently
    // submitted an empty/wrong param set for any mobile input that wasn't that exact class
    // (e.g. the Size/Gender swatch checkboxes).
    const mobileForm = event.target.closest('.mobile-facets');
    if (mobileForm) {
      const searchParams = this.createSearchParams(mobileForm);
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const sortFilterForms = document.querySelectorAll('facet-filters-form form');
      sortFilterForms.forEach((form) => {
        if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
          const noJsElements = document.querySelectorAll('.no-js-list');
          noJsElements.forEach((el) => el.remove());
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

addFocusToClearAll() {
  const clearAllButton = document.querySelector('.active-facets .active-facets__button-remove .focus-active');
  if (clearAllButton) {
    clearAllButton.focus();
  }
}

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);


// Desktop filter-group accordions (.facets__summary / .facets__display[-vertical]).
// Visibility is driven purely by the aria-expanded attribute + CSS (see
// component-facets.css), so this only needs to flip that attribute on click.
// Delegated on `document` so it keeps working after AJAX re-renders swap the
// underlying markup. Deliberately just a plain independent toggle — no
// "close the others" / "close on outside click" behavior, since that extra
// cleverness was fighting itself and causing the accordions to need two
// clicks to open and never close.
document.addEventListener("click", function (event) {
  const button = event.target.closest(".facets__summary[aria-controls]");
  if (!button) return;

  event.preventDefault();
  const isOpen = button.getAttribute("aria-expanded") === "true";
  button.setAttribute("aria-expanded", isOpen ? "false" : "true");
});